import { DateTime } from 'luxon';
import { BeaconFunctionAppProperties } from '../../../common/beacon.interfaces';
import { Badge, Form } from 'react-bootstrap';
import { useState } from 'react';
import FavoriteSvg from '../../svg/FavoriteSvg';
import EditPencilSvg from '../../svg/EditPencilSvg';
import '../../../styles/beacon.css'

export default function BeaconFunctionAppTable(props: BeaconFunctionAppProperties) {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const handleFocus = (id: string) => {
    setExpandedId(id); // Only one input can be expanded at a time
  };

  const handleBlur = (id: string) => {
    // Optional: Delay collapsing to allow clicking inside the textarea
    setTimeout(() => {
      if (expandedId === id) {
        setExpandedId(null);
      }
    }, 100); 
  };

  const tags: string[] = JSON.parse(props.beaconFunctionAppsRow?.tags ?? '[]')

  return (
    <div id={props.functionApp} className='beacon-card'>
      <div key={`${props.functionApp}-${props.type}`} className='beacon-function-app'>
        <h1>{props.functionApp} {<FavoriteSvg height={25} selected={props.beacons.some(b => b.isFavorite === true)}/>} <span data-functionApp={props.functionApp} onClick={props.handleEditFunctionApp} title={`Edit beacon settings for ${props.functionApp}`} style={{cursor: 'pointer'}}>{ <EditPencilSvg height={16} />}</span></h1>
        <div style={{padding: '2px'}}>
          <a className='beacon-link' href={`#top`}>
            <svg
              height="18"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
            </svg> top
          </a>&nbsp;&nbsp;&nbsp;&nbsp;
          <a className='beacon-link' target="_blank" rel="noopener noreferrer" href={`https://github.com/nhsllc/${props.functionApp}`}>
            <svg height="18" aria-hidden="true" viewBox="0 0 24 24" version="1.1" width="32" >
              <path d="M12 1C5.9225 1 1 5.9225 1 12C1 16.8675 4.14875 20.9787 8.52125 22.4362C9.07125 22.5325 9.2775 22.2025 9.2775 21.9137C9.2775 21.6525 9.26375 20.7862 9.26375 19.865C6.5 20.3737 5.785 19.1912 5.565 18.5725C5.44125 18.2562 4.905 17.28 4.4375 17.0187C4.0525 16.8125 3.5025 16.3037 4.42375 16.29C5.29 16.2762 5.90875 17.0875 6.115 17.4175C7.105 19.0812 8.68625 18.6137 9.31875 18.325C9.415 17.61 9.70375 17.1287 10.02 16.8537C7.5725 16.5787 5.015 15.63 5.015 11.4225C5.015 10.2262 5.44125 9.23625 6.1425 8.46625C6.0325 8.19125 5.6475 7.06375 6.2525 5.55125C6.2525 5.55125 7.17375 5.2625 9.2775 6.67875C10.1575 6.43125 11.0925 6.3075 12.0275 6.3075C12.9625 6.3075 13.8975 6.43125 14.7775 6.67875C16.8813 5.24875 17.8025 5.55125 17.8025 5.55125C18.4075 7.06375 18.0225 8.19125 17.9125 8.46625C18.6138 9.23625 19.04 10.2125 19.04 11.4225C19.04 15.6437 16.4688 16.5787 14.0213 16.8537C14.42 17.1975 14.7638 17.8575 14.7638 18.8887C14.7638 20.36 14.75 21.5425 14.75 21.9137C14.75 22.2025 14.9563 22.5462 15.5063 22.4362C19.8513 20.9787 23 16.8537 23 12C23 5.9225 18.0775 1 12 1Z"></path>
            </svg>
          </a>
          {tags.map(t => <><Badge bg='secondary'>{t}</Badge>&nbsp;&nbsp;</>)}
        </div>
        
        <div className='beacon-function'>
          <table key={`${props.functionApp}-beacon-table`} style={{width: '100%'}}>
            <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 10 }}>
              <tr key={`${props.functionApp}-beacon-table-headers`} style={{background: 'rgb(248, 248, 248)'}}>
                <td>function</td>
                <td>trigger</td>
                <td>last start</td>
                <td>last complete</td>
                <td>since last complete</td>
                <td>start to complete</td>
                <td>fave</td>
                <td>edit</td>
              </tr>
            </thead>
            <tbody>
              {
                props.beacons.map(b => (
                  <>
                  <tr id={`${b.partitionKey}-${b.rowKey}`} key={`${props.functionApp}-${props.type}-${b.rowKey}`}>
                    <td>
                      <span className='beacon-header'>{b.rowKey}</span>
                    </td>
                    <td>
                      <span>{b.functionsRow?.functionTrigger}{b.functionsRow?.functionTrigger === 'timer' ? ` every ${b.functionsRow?.timerTimeInMinutes} minute(s)` : ''}</span>
                    </td>
                    <td>
                      {DateTime.fromISO(b.lastRun).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
                    </td>
                    <td>
                      {DateTime.fromISO(b.lastComplete).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}
                    </td>
                    <td style={{fontWeight: 'lighter'}}>
                      <span>{b.sinceLastCompleteSeconds.toFixed(0)}s</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.sinceLastCompleteMinutes.toFixed(2)}m</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.sinceLastCompleteHours.toFixed(2)}h</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.sinceLastCompleteDays.toFixed(2)}d</span>
                    </td>
                    <td style={{fontWeight: 'lighter'}}>
                      <span>{b.startToCompleteSeconds.toFixed(0)}s</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.startToCompleteMinutes.toFixed(2)}m</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.startToCompleteHours.toFixed(2)}h</span>&nbsp;&nbsp;&nbsp;
                      <span>{b.startToCompleteDays.toFixed(2)}d</span>
                    </td>
                    <td style={{cursor: 'pointer'}}>{b.isFavorite === true 
                      ? <div onClick={props.handleFavoriteClicked} data-functionapp={props.functionApp} data-func={b.rowKey} data-isfavorited='false'>{<FavoriteSvg height={25} selected={true}/>}</div> 
                      : <div onClick={props.handleFavoriteClicked} data-functionapp={props.functionApp} data-func={b.rowKey} data-isfavorited='true'>{<FavoriteSvg height={25} selected={false}/>}</div>}
                    </td>
                    <td style={{cursor: 'pointer'}}>
                      <span data-functionapp={props.functionApp} data-func={b.rowKey} onClick={props.handleEditFunction} title={`Edit beacon settings for ${b.rowKey}`} style={{cursor: 'pointer'}}>{ <EditPencilSvg height={16} />}</span>
                    </td>
                  </tr>
                  {(b.functionsRow && b.functionsRow?.tags && JSON.parse(b.functionsRow?.tags).length > 0) ? (
                    <tr>
                      <td colSpan={8} className='beacon-label'>
                        {JSON.parse(b.functionsRow?.tags).map(tag => (
                          <>
                            <Badge key={tag} bg='secondary'>{tag}</Badge>&nbsp;
                          </>
                        ))}
                      </td>
                    </tr>
                  ) : null}
                  {b.logsTableRow ? <tr key={`${props.functionApp}-${props.type}-${b.rowKey}-error`} >
                    <td style={{background: '#ffffffa1'}} colSpan={8}>
                      <div>
                        <span>Last on-call event @ <strong>{DateTime.fromISO(b.logsTableRow?.timestamp).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)}</strong>&nbsp;&nbsp;&nbsp;</span>
                        <span>{DateTime.utc().diff(DateTime.fromISO(b.logsTableRow?.timestamp), 'seconds').seconds.toFixed(2)}s&nbsp;&nbsp;&nbsp;</span>
                        <span>{DateTime.utc().diff(DateTime.fromISO(b.logsTableRow?.timestamp), 'minutes').minutes.toFixed(2)}m&nbsp;&nbsp;&nbsp;</span>
                        <span>{DateTime.utc().diff(DateTime.fromISO(b.logsTableRow?.timestamp), 'hours').hours.toFixed(2)}h&nbsp;&nbsp;&nbsp;</span>
                        <span>{DateTime.utc().diff(DateTime.fromISO(b.logsTableRow?.timestamp), 'days').days.toFixed(2)}d&nbsp;&nbsp;&nbsp;</span>
                        <span title={'View the Azure content in the browser'} data-app={b.partitionKey} data-func={b.rowKey} data-blobpath={b.logsTableRow?.blobName} onClick={props.handleViewError} className='beacon-link'>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height={16}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-6 h-6"
                          >
                            <path d="M1 12s3-7 11-7 11 7 11 7-3 7-11 7-11-7-11-7z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </span>
                        &nbsp;&nbsp;
                        <span title={'Download the Azure content'} data-app={b.partitionKey} data-func={b.rowKey} data-blobpath={b.logsTableRow?.blobName} onClick={props.handleDownloadError} className='beacon-link'>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height={16}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="w-6 h-6"
                          >
                            <path d="M12 3v12M18 15l-6 6-6-6" />
                          </svg>
                        </span>

                        <Form.Control
                          as={expandedId === b.logsTableRow.rowKey ? "textarea" : "input"}
                          defaultValue={b.logsTableRow.details}
                          onFocus={() => handleFocus(b.logsTableRow.rowKey)}
                          onBlur={() => handleBlur(b.logsTableRow.rowKey)}
                        />
                      </div>
                    </td>
                  </tr>: ''}
                  </>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}